
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collezioni/brand/[slug_brand]/[slug_collezione]",
      function () {
        return require("private-next-pages/collezioni/brand/[slug_brand]/[slug_collezione]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collezioni/brand/[slug_brand]/[slug_collezione]"])
      });
    }
  